import React from 'react';

import { Box, CircularProgress, Typography } from '@mui/material';

interface Props {
  label: string;
  value: string;
  caption?: string;
  isLoading?: boolean;
  minWidth?: number;
  maxWidth?: number;
}

export default function KpiTile({ label, value, caption, isLoading = false, minWidth = 220, maxWidth = 260 }: Props) {
  return (
    <Box
      sx={{
        minWidth,
        maxWidth,
        border: 1,
        borderColor: 'primary.light',
        borderRadius: 2,
        px: 2,
        py: 1.5,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <Typography
        sx={{
          fontSize: 11,
          fontWeight: 700,
          color: 'text.secondary',
          letterSpacing: 0.5,
          textTransform: 'uppercase',
        }}
      >
        {label}
      </Typography>
      {isLoading ? (
        <CircularProgress size={20} sx={{ mt: 0.5 }} />
      ) : (
        <Typography sx={{ fontSize: 32, fontWeight: 700, color: 'primary.main', lineHeight: 1.2 }}>{value}</Typography>
      )}
      {caption && <Typography sx={{ fontSize: 12, color: 'text.secondary', mt: 0.5 }}>{caption}</Typography>}
    </Box>
  );
}
